import React, { FC } from 'react';

import { Box, Typography } from '@mui/material';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import ChevronTopIcon from '../../assets/icons/ChevronTopIcon';
import { BREAKPOINTS_VALUES } from '../../theme';
import { AllProfessionals } from '../../types';
import IKImage from '../IKImage/IKImage';
import { LazyLoadImage } from '../LazyloadImage';
import useStyles from './styles';

interface HalfWidthImgBlockProps {
  data: AllProfessionals;
}

const HalfWidthImgBlock: FC<HalfWidthImgBlockProps> = ({ data }) => {
  const background = data?.background;
  const desktopImg = data?.image;
  const heading = data?.heading;
  const items = data?.content;

  const { t } = useTranslation();

  const classes = useStyles(background)();

  if (!items?.length) return null;

  return (
    <Box
      className={cx(
        classes.wrapper,
        background === 'Dark' ? 'dark-block' : 'light-block',
        'half-width-img-block',
      )}
    >
      <Box className={cx(classes.halfWidthImg, 'half-width-img')}>
        {desktopImg && (
          <LazyLoadImage
            path={desktopImg}
            draggable={false}
            alt={heading}
            srcset={[{ width: 900 }]}
            sizes={`(min-width:${BREAKPOINTS_VALUES['md']}px) 900px`}
          />
        )}
      </Box>
      <Box className={classes.content}>
        <Typography variant="h2" component="h2" className={classes.heading}>
          {heading}
        </Typography>

        <Box className={classes.items}>
          {items &&
            items.map((item) => {
              const heading = item?.title;
              const description = item?.sub_title || t('block.halfImgBlock.seePathways');

              return (
                //TODO change to Link after WP remove
                <a
                  href={item?.link || '#'}
                  key={item?.image}
                  className={cx(classes.item, 'half-width-img-block__item')}
                >
                  <div className={classes.imageWrap}>
                    <IKImage
                      path={item?.image}
                      draggable={false}
                      alt={heading}
                      srcset={[{ width: 54 }, { width: 50 }]}
                      sizes={`(max-width:${BREAKPOINTS_VALUES['md']}px) 54px, 50px`}
                    />
                  </div>
                  <div className={classes.textWrapper}>
                    <Typography variant="h3" component="h3" className={classes.itemTitle}>
                      {heading}
                      <ChevronTopIcon className={classes.itemIcon} />
                    </Typography>
                    <Typography className={classes.itemText}>{description}</Typography>
                  </div>
                </a>
              );
            })}
        </Box>
      </Box>
    </Box>
  );
};

export default HalfWidthImgBlock;
